import React from 'react';

// Define a mapping for icons
export const iconMapping = {
    positions: 'https://storage.googleapis.com/finiat-web-static-resources/appIcons/etfMatrix.png',
    smalab: 'https://storage.googleapis.com/finiat-web-static-resources/appIcons/sma-lab.png',
    blacklist: 'https://storage.googleapis.com/finiat-web-static-resources/appIcons/blacklist-checkmark.png',
    screener: 'https://storage.googleapis.com/finiat-web-static-resources/appIcons/screener-letters.webp',
    formBuilder: 'https://storage.googleapis.com/finiat-web-static-resources/appIcons/model-builder-alt-2.png',
    portfolios: 'https://storage.googleapis.com/finiat-web-static-resources/appIcons/portfolio-delta.png',
    performanceComparison: 'https://storage.googleapis.com/finiat-web-static-resources/appIcons/comparison-two-tone.png',
    signals: 'https://storage.googleapis.com/finiat-web-static-resources/appIcons/signals.png',
    portfolioBuilder: 'https://storage.googleapis.com/finiat-web-static-resources/appIcons/build.png',
    settings: 'https://storage.googleapis.com/finiat-web-static-resources/appIcons/settings.png',
    prospects: 'https://storage.googleapis.com/finiat-web-static-resources/appIcons/prospects.png',
    superUser: 'https://storage.googleapis.com/finiat-web-static-resources/appIcons/super-user-alt-1.png',
    files: 'https://storage.googleapis.com/finiat-web-static-resources/appIcons/files-alt-1.png',
    touchpoints: 'https://storage.googleapis.com/finiat-web-static-resources/appIcons/pulsa-app-icon.png',
    iq: 'https://storage.googleapis.com/finiat-web-static-resources/appIcons/iq-icon-2.png',
};


const SuperUserApp = { label: 'SuperUser', iconUrl: iconMapping.superUser, key: 'superuser', path: '/superuser' }

// Define all available apps in one common array
export const allApps = [
    { label: 'ETF Matrix', iconUrl: iconMapping.positions, key: 'positions', path: '/etfs/matrix' },
    { label: 'i-INDEX', iconUrl: iconMapping.smalab, key: 'smalab', path: '/builders/sma' },
    { label: 'Blacklist', iconUrl: iconMapping.blacklist, key: 'blacklist', path: '/widgets/blacklist' },
    { label: 'Screener', iconUrl: iconMapping.screener, key: 'screener', path: '/screener' },
    { label: 'Model Builder', iconUrl: iconMapping.formBuilder, key: 'formBuilder', path: '/builders/model' },
    { label: 'Portfolios', iconUrl: iconMapping.portfolios, key: 'portfolios', path: '/portfolios' },
    { label: 'Performance', iconUrl: iconMapping.performanceComparison, key: 'performanceComparison', path: '/performance/comparison' },
    { label: 'Signals', iconUrl: iconMapping.signals, key: 'signals', path: '/signals' },
    { label: 'Builders', iconUrl: iconMapping.portfolioBuilder, key: 'portfolioBuilder', path: '/builders/landing' },
    { label: "Prospects", iconUrl: iconMapping.prospects, key: 'prospects', path: '/prospects' },
    { label: 'Files', iconUrl: iconMapping.files, key: 'files', path: '/files' },
];

// Function to filter apps based on user's keys
export const filterAppsForUser = (userAppKeys, prefix='') => {
    let filteredApps = allApps.filter(app => userAppKeys.includes(app.key));
    filteredApps.sort((a, b) => userAppKeys.indexOf(a.key) - userAppKeys.indexOf(b.key));
    if (localStorage.getItem('uid') === 'finiat'){
        filteredApps.push(SuperUserApp)
    }
    return [...filteredApps, allApps.find(app=>app.key==='files')].map(x=>({...x, path: prefix+x.path}));
};
